import React from 'react';
import Script from 'next/script';
import {
  AD_LIGHT_HTML_ATTR,
  AD_LIGHT_STORAGE_KEY,
  FREESTAR_PUBLISHER,
  FREESTAR_STICKY_FOOTER_MOBILE_ENABLED,
  FREESTAR_STICKY_FOOTER_MOBILE_PLACEMENT,
} from '@benzinga/ads-utils';

const FREESTAR_PUBFIG_SRC = `https://a.pub.network/${FREESTAR_PUBLISHER}/pubfig.min.js`;

const FREESTAR_QUEUE_BOOTSTRAP = `
(function () {
  try {
    var forceAds = /[?&]adlight=(false|0)(?:&|$)/.test(location.search);
    var adLight =
      !forceAds &&
      (document.documentElement.getAttribute('${AD_LIGHT_HTML_ATTR}') === 'true' ||
        localStorage.getItem('${AD_LIGHT_STORAGE_KEY}') === 'true');
    var freestar = window.freestar || {};
    freestar.queue = freestar.queue || [];
    freestar.config = freestar.config || {};
    freestar.config.enabled_slots = freestar.config.enabled_slots || [];
    window.freestar = freestar;
    window.freestarReactCompontentLoaded = true;
    if (adLight) {
      freestar.config.disabledProducts = Object.assign({}, freestar.config.disabledProducts || {}, {
        googleInterstitial: true,
        stickyFooter: true,
        stickyRail: true,
      });
    } else {
      ${
        FREESTAR_STICKY_FOOTER_MOBILE_ENABLED
          ? `freestar.queue.push(function () {
        if (!window.matchMedia('(max-width: 767px)').matches) return;
        if (typeof window.freestar.newStickyFooter === 'function') {
          window.freestar.newStickyFooter(${JSON.stringify(FREESTAR_STICKY_FOOTER_MOBILE_PLACEMENT)});
        }
      });`
          : `if (window.matchMedia('(max-width: 767px)').matches) {
        freestar.config.disabledProducts = Object.assign(freestar.config.disabledProducts || {}, { stickyFooter: true });
      }`
      }
    }
    var pubfig = document.createElement('script');
    pubfig.async = false;
    pubfig.id = 'freestar-pubfig';
    pubfig.setAttribute('data-cfasync', 'false');
    pubfig.src = ${JSON.stringify(FREESTAR_PUBFIG_SRC)};
    document.head.appendChild(pubfig);
  } catch (error) {}
})();
`.trim();

export const FreestarPubfig: React.FC = () => (
  <Script data-cfasync="false" id="freestar-queue" strategy="beforeInteractive">
    {FREESTAR_QUEUE_BOOTSTRAP}
  </Script>
);
